import { render, staticRenderFns } from "./YearEndDistributionsTable.vue?vue&type=template&id=0bf387da"
import script from "./YearEndDistributionsTable.vue?vue&type=script&lang=js"
export * from "./YearEndDistributionsTable.vue?vue&type=script&lang=js"
import style0 from "./YearEndDistributionsTable.vue?vue&type=style&index=0&id=0bf387da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports